import React, { Component } from 'react'
import Select from 'react-select/lib/Creatable';

class CreatableSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: ""
    };
    this.handleChange = this.handleChange.bind(this);
  }
  
  handleChange(selectedOption) {
    console.log(selectedOption);
    if (selectedOption) {
      if (this.props.isMulti) {
        this.props.input.onChange(selectedOption);
      } else {
        this.props.input.onChange(selectedOption);
      }
    } else {
      this.props.input.onChange("");
    }
  }
  
  render() {
    return (
      <Select
        {...this.props}
        name={this.props.input.name}
        value={this.props.input.value}
        cacheOptions
        onChange={this.handleChange}
        formatCreateLabel={(value) => `Send to: ${value}`}
      />
    )
  }
}

export default CreatableSelect



// WEBPACK FOOTER //
// ./src/system/fields/CreatableSelect/index.jsx